const defaultState = () => ({
    showSuccess: false,
    egeSubjects: [],
    egeSubjectsList: [],
    egeSubjectsPerPage: 3,
    currentSubjectId: null
});
export default defaultState;
